var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    clipRule: "evenodd",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M113.484 62.809C15.269 108.279 28 221.954 146.222 348.36 256.26 465.673 318.1 488.408 379.03 434.753c31.829-27.282 91.85-106.4 84.574-110.947-.91-.909-37.285-7.275-80.027-13.64-95.487-14.551-146.414-30.92-202.796-66.387-60.93-38.195-84.575-94.577-64.568-148.232 9.094-23.644 57.292-40.923 85.484-30.01 15.46 5.456 20.007 5.456 13.64-.91-19.097-19.097-62.748-20.006-101.852-1.818z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M313.552 72.812c51.836 40.923 37.285 115.494-30.01 161.873-20.007 13.641-35.467 27.282-36.376 30.92 0 6.366 90.03 30.01 94.577 24.554 30.92-39.105 50.927-81.846 50.927-110.947 0-59.111-44.56-123.679-85.484-124.588-14.55 0-13.64 2.728 6.366 18.188z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.b68e29b721781cb0267d0ff6df972b15.svg";
export { ForwardRef as ReactComponent };